import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=10817fd2&"
import script from "./upgrade.vue?vue&type=script&lang=js&"
export * from "./upgrade.vue?vue&type=script&lang=js&"
import style0 from "./upgrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports